import React from 'react';
import { formatNumber } from '../../utils/helpers';
import './PnLSummaryCards.css';

/**
 * PnL Summary Cards Component
 * Shows wallet PnL stats for different time periods
 * Following grey-black theme
 */
function PnLSummaryCards({ walletData, loading }) {
  if (loading) {
    return (
      <div className="pnl-summary-cards">
        <div className="pnl-card loading">
          <div className="spinner-border spinner-border-sm text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (!walletData) {
    return null;
  }

  const cards = [
    {
      label: '24h PnL',
      value: walletData.pnl24h || 0,
      period: '24h'
    },
    {
      label: '7d PnL',
      value: walletData.pnl7d || 0,
      period: '7d'
    },
    {
      label: '30d PnL',
      value: walletData.pnl30d || 0,
      period: '30d'
    },
    {
      label: 'Total PnL',
      value: walletData.pnlTotal || 0,
      period: 'all',
      isTotal: true
    }
  ];

  const formatPnL = (value) => {
    const formatted = formatNumber(Math.abs(value));
    return value >= 0 ? `+${formatted}` : `-${formatted}`;
  };

  const getPnLClass = (value) => {
    if (value > 0) return 'positive';
    if (value < 0) return 'negative';
    return 'neutral';
  };

  return (
    <div className="pnl-summary-cards">
      {cards.map((card, index) => (
        <div key={index} className={`pnl-card ${card.isTotal ? 'total' : ''} ${getPnLClass(card.value)}`}>
          <div className="pnl-card-header">
            <span className="pnl-label">{card.label}</span>
            {card.value > 0 && <span className="pnl-icon">↗</span>}
            {card.value < 0 && <span className="pnl-icon">↘</span>}
          </div>
          <div className="pnl-value-row">
            <span className="pnl-value">{formatPnL(card.value)}</span>
            {card.isTotal && <span className="pnl-badge">All Time</span>}
          </div>
        </div>
      ))}

      {/* Account Value Card */}
      <div className="pnl-card account-value">
        <div className="pnl-card-header">
          <span className="pnl-label">Account Value</span>
        </div>
        <div className="pnl-value">{formatNumber(walletData.accountValue || 0)}</div>
      </div>

      {/* Free Margin Card */}
      <div className="pnl-card free-margin">
        <div className="pnl-card-header">
          <span className="pnl-label">Free Margin</span>
        </div>
        <div className="pnl-value">{formatNumber(walletData.freeMargin || 0)}</div>
      </div>

      {/* Total Position Value Card */}
      <div className="pnl-card position-value">
        <div className="pnl-card-header">
          <span className="pnl-label">Position Value</span>
        </div>
        <div className="pnl-value">{formatNumber(walletData.totalPositionValue || 0)}</div>
      </div>
    </div>
  );
}

export default PnLSummaryCards;
